import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";

export default function PrincipalNameSuggestionDialog({
  open,
  suggestedLabel,
  attorneyUiIsProbate,
  onBackdropSafeClose,
  onDecline,
  onConfirm,
}) {
  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") onBackdropSafeClose();
      }}
    >
      <DialogTitle>Similar Professional Guardian Found</DialogTitle>
      <DialogContent>
        {attorneyUiIsProbate ? (
          <DialogContentText>
            The name you entered is close to {suggestedLabel}. Would you like to select{" "}
            {suggestedLabel} as a Professional Guardian?
          </DialogContentText>
        ) : (
          <Typography>
            The name you entered is close to {suggestedLabel}. Would you like to select{" "}
            {suggestedLabel} as a Professional Guardian?
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onDecline} color="secondary">
          No
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          Yes, Select
        </Button>
      </DialogActions>
    </Dialog>
  );
}

PrincipalNameSuggestionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  suggestedLabel: PropTypes.string,
  attorneyUiIsProbate: PropTypes.bool.isRequired,
  onBackdropSafeClose: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
